
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

 require("@babel/polyfill");
 require('./bootstrap');
 const axios = require('axios');
 const bugsnag = require('@bugsnag/js');
 const bugsnagVue = require('@bugsnag/plugin-vue');
 //import DropdownMenu from '@innologica/vue-dropdown-menu';
 
 window.Vue = require('vue');

 //Vue.use(DropdownMenu);
 
 const bugsnagClient = bugsnag({ 
     apiKey:'01cc70d1b9f2cd82290e634ef99b5b2d',
     releaseStage: process.env.NODE_ENV
 });
 bugsnagClient.use(bugsnagVue, Vue);


 
 /**
  * The following block of code may be used to automatically register your
  * Vue components. It will recursively scan this directory for the Vue
  * components and automatically register them with their "basename".
  *
  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
  */
 
 // const files = require.context('./', true, /\.vue$/i);
 // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
 
 Vue.component('dropdown-menu', require('./components/DropDown.vue').default);
 Vue.component('all-signatures', require('./components/AllSignatures.vue').default);
 Vue.component('view-sig-employees', require('./components/ViewSigEmployees.vue').default);
 Vue.component('employees', require('./components/Employees.vue').default);
 Vue.component('view-employee', require('./components/ViewEmployee.vue').default);
 Vue.component('pagination', require('laravel-vue-pagination'));
 Vue.component('org-users', require('./components/OrgUsers.vue').default);
 Vue.component('org-billing', require('./components/OrgBilling.vue').default);
 Vue.component('org-settings', require('./components/OrgSettings.vue').default);
 Vue.component('home', require('./components/Home.vue').default);
 Vue.component('pricing', require('./components/Pricing.vue').default);
 Vue.component('basic-instructions', require('./components/BasicInstructions.vue').default);
 Vue.component('collapse', require('./components/Collapse.vue').default);
 Vue.component('landing-page', require('./components/LandingPage.vue').default);
 Vue.component('purchase-modal', require('./components/PurchaseModal.vue').default);
 Vue.component('upgrade-modal', require('./components/UpgradeModal.vue').default);
 Vue.component('signature-access-code', require('./components/SignatureAccessCode.vue').default);
 Vue.component('image-modal', require('./components/ImageModal.vue').default);
 Vue.component('contact-form', require('./components/ContactForm.vue').default);
 Vue.component('enterprise-payment', require('./components/EnterprisePayment.vue').default);
 Vue.component('youtube-embed-lite', require('./components/YoutubeEmbedLite.vue').default);
 
 /**
  * Next, we will create a fresh Vue application instance and attach it to
  * the page. Then, you may begin adding components to this application
  * or customize the JavaScript scaffolding to fit your unique needs.
  */
 
 const app = new Vue({
    el: '#app'
 });
 